 
import Portal from "../../../../platform/pages/business/portal";
import CareProviderDashboardPage from "./careProviderDashboardPage";

const CareProviderDashboard = (props) => {
  return (
    <Portal TabComponent={CareProviderDashboardPage} props={props} />
  );
};
export default CareProviderDashboard;
